<app-document-subheader/>
@let claimType = this.claimType$ | async;
<div class="details-content container-fluid h-100">
  <div class="row h-100">
    <div class="col-content d-flex flex-column h-100">
      @if (claimType) {
        <div class="page-container">
          <div class="card card-light w-100">
            <div class="card-body">
              <div class="container-fluid">
                <div class="row mb-2">
                  <div class="col-12 col-md-9 mr-auto">
                    <div class="form-group">
                      <label class="form-title-label" translate
                      >CLAIM_TYPE_LBL_NAME</label
                      >
                      <div class="form-title">{{ claimType.name }}</div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 col-md-6">
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >CLAIM_TYPE_LBL_PRODUCT_CATEGORY</label
                      >
                      <div class="col">
                        <span class="form-control-plaintext form-control-sm">
                          {{ claimType.productCategoryName }}
                        </span>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >CLAIM_TYPE_LBL_DEFAULT_FEE</label
                      >
                      <div class="col">
                        <span class="form-control-plaintext form-control-sm">
                          @if (claimType.defaultFeeAmount === null || claimType.defaultFeeAmount === undefined) {
                            -
                          } @else {
                            {{ claimType.defaultFeeAmount | showSignValueType: 'Monetary' }}
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <!--                    <div class="form-group row">-->
                    <!--                      <label class="col-4 col-form-label-sm" translate-->
                    <!--                      >CLAIM_TYPE_LBL_SEQUENCE</label-->
                    <!--                      >-->
                    <!--                      <div class="col">-->
                    <!--                        <span class="form-control-plaintext form-control-sm">-->
                    <!--                          {{ claimType.sequence }}-->
                    <!--                        </span>-->
                    <!--                      </div>-->
                    <!--                    </div>-->
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                      >CLAIM_TYPE_LBL_ACTIVE</label
                      >
                      <div class="col">
                        <span class="form-control-plaintext form-control-sm">
                          <input
                            type="checkbox"
                            name="active"
                            [(ngModel)]="claimType.active"
                            onclick="return false;"
                            disabled
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                @if (claimType.claimTypeDocumentTypes && claimType.claimTypeDocumentTypes.length > 0) {
                  <div class="row mt-3">
                    <div class="col">
                      <label class="form-title-label mb-2" translate
                      >CLAIM_TYPE_LBL_DOCUMENTS</label
                      >
                      <app-generic-grid
                        style="height: 300px"
                        [data]="claimType.claimTypeDocumentTypes"
                        [tabViewName]="'claimTypesDocumentTypes'"
                      />
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    @if (claimType) {
      <div class="col-comment">
        <app-comment-panel
          [entityType]="'ClaimType'"
          [entityId]="claimType.id.toString()"
        ></app-comment-panel>
      </div>
    }
  </div>
</div>
